import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import BottomNav from './components/BottomNav';
import Dashboard from './components/Dashboard';
import Plans from './components/Plans';
import Deposit from './components/Deposit';
import Withdraw from './components/Withdraw';
import Profile from './components/Profile';
import History from './components/History';
import Login from './components/Login';
import Register from './components/Register';
import MyPlans from './components/MyPlans';
import ContactPage from './components/ContactPage';
import ReferralDashboard from './components/ReferralDashboard';
import TermsAndConditions from './components/TermsAndConditions';

import './index.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/" /> : children;
};

function App() {
  return (
    <Router>
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0a0a0a'
      }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          } />

          {/* Private Routes */}
          <Route path="/" element={
            <PrivateRoute>
              <>
                <Dashboard />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/referral" element={
            <PrivateRoute>
              <>
                <ReferralDashboard />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/plans" element={
            <PrivateRoute>
              <>
                <Plans />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/deposit" element={
            <PrivateRoute>
              <>
                <Deposit />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/myplans" element={
            <PrivateRoute>
              <>
                <MyPlans />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/contact" element={
            <PrivateRoute>
              <>
                <ContactPage />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/withdraw" element={
            <PrivateRoute>
              <>
                <Withdraw />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/profile" element={
            <PrivateRoute>
              <>
                <Profile />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/history" element={
            <PrivateRoute>
              <>
                <History />
                <BottomNav />
              </>
            </PrivateRoute>
          } />
          <Route path="/terms" element={
  <PrivateRoute>
    <>
      <TermsAndConditions />
      <BottomNav />
    </>
  </PrivateRoute>
} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;